export default __webpack_public_path__ + "static/media/logo-apple.f9c2682e.svg";